// Normalises a GUID for comparison: lower case, without braces or hyphens. Null when it isn't a GUID.
export const normalizeGuid = (guid: string | null | undefined): string | null => {
    const compact = guid?.trim().replace(/[{}-]/g, "").toLowerCase() ?? "";
    return /^[0-9a-f]{32}$/.test(compact) ? compact : null;
};
